<app-onboarding-landing *ngIf="mode === 'landing'" (modeSelected)="onModeSelected($event)"
  (filesUploaded)="onFilesUploaded($event)">
</app-onboarding-landing>
<div class="peer-signup-container"style="margin-top: -2rem; margin-bottom:-5rem;" *ngIf="mode !== 'landing'">
  <div class="wizard-layout">

    <!-- SIDEBAR -->
    <aside class="wizard-sidebar">
      <div class="sidebar-mobile-header">
        <div class="header-left">
          <div class="sidebar-count-circle">
            <span class="count">{{ activeIndex + 1 }}/{{ items.length }}</span>
            <span class="label">steps</span>
          </div>
        </div>
        <div class="header-right">
          <h2 class="mobile-step-title">{{ items[activeIndex].title }}</h2>
          <p class="mobile-next-step" *ngIf="activeIndex < items.length - 1">
            Next &rarr; <span class="highlight">{{ items[activeIndex + 1].title }}</span>
          </p>
        </div>
      </div>

      <div class="mobile-progress-bar">
        <div class="progress-segment" *ngFor="let item of items; let i = index" [class.active]="activeIndex >= i"
          [class.current]="activeIndex === i">
        </div>
      </div>

      <div class="sidebar-top desktop-only">
        <div class="sidebar-count-circle">
          <span class="count">{{ activeIndex + 1 }}/{{ items.length }}</span>
          <span class="label">steps</span>
        </div>
        <p class="sidebar-status-label">IN PROGRESS</p>
      </div>

      <div class="sidebar-steps desktop-only">
        <button type="button" class="sidebar-step" *ngFor="let item of items; let i = index"
          [class.active]="activeIndex === i" [class.completed]="activeIndex > i" (click)="activeIndex = i"
          [disabled]="activeIndex < i && isNextDisabled">
          <span class="step-circle">
            <i *ngIf="activeIndex > i" class="pi pi-check"></i>
            <span *ngIf="activeIndex <= i">{{ i + 1 }}</span>
          </span>
          <span class="step-info">
            <span class="step-name">{{ item.title }}</span>
            <span class="step-caption">{{ items[i]['subtitle'] }}</span>
          </span>
        </button>
      </div>

    </aside>

    <!-- MAIN CONTENT -->
    <main class="wizard-main">
      <div class="wizard-header desktop-only">
        <h1>{{ items[activeIndex].title }}</h1>
      </div>

      <div class="wizard-form">
        <form [formGroup]="onboardingForm" class="onboarding-form">
          <div class="step-content">
            <div [ngSwitch]="activeIndex">
              <app-education-info *ngSwitchCase="0" [parentForm]="onboardingForm" (stepSaved)="onStepSaved()"
                (saveFailed)="onStepFailed()" (stepStatusChanged)="isNextDisabled = !$event">
              </app-education-info>
              <app-test-scores *ngSwitchCase="1" [parentForm]="onboardingForm" (stepSaved)="onStepSaved()"
                (saveFailed)="onStepFailed()" (stepStatusChanged)="isNextDisabled = !$event">
              </app-test-scores>
              <app-recommendations *ngSwitchCase="2" [parentForm]="onboardingForm" (stepSaved)="onStepSaved()"
                (saveFailed)="onStepFailed()" (stepStatusChanged)="isNextDisabled = !$event">
              </app-recommendations>
              <app-experiences *ngSwitchCase="3" [parentForm]="onboardingForm" (stepSaved)="onStepSaved()"
                (saveFailed)="onStepFailed()" (stepStatusChanged)="isNextDisabled = !$event">
              </app-experiences>
              <app-awards-accolades *ngSwitchCase="4" [parentForm]="onboardingForm" (stepSaved)="onStepSaved()"
                (saveFailed)="onStepFailed()" (stepStatusChanged)="isNextDisabled = !$event">
              </app-awards-accolades>
            </div>
          </div>

          <!-- FOOTER -->
          <div class="wizard-footer" [class.final-step-footer]="activeIndex === items.length - 1">
            <div class="footer-progress-info" *ngIf="activeIndex < items.length - 1">
              <div class="progress-dots">
                <div class="dot" *ngFor="let item of items; let idx = index" [class.active]="activeIndex === idx"></div>
              </div>
              <div class="step-text">Step {{ activeIndex + 1 }} of {{ items.length }}</div>
            </div>

            <div class="footer-buttons">
              <button pButton type="button" class="btn btn-secondary" (click)="prevStep()"
                [disabled]="activeIndex === 0">
                <i class="pi pi-chevron-left"></i> Back
              </button>

              <span pTooltip="Kindly hit save button to continue" [tooltipDisabled]="!isNextDisabled" tooltipPosition="top">
                <button pButton type="button" class="btn btn-primary" (click)="nextStep()">
                  {{ getFooterLabel() }}
                  <i class="pi pi-chevron-right"></i>
                </button>
              </span>
            </div>
          </div>
        </form>
      </div>
    </main>
  </div>
</div>

<p-toast></p-toast>